import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { AppLogoIcon } from "../../Icons";
import { AuthPageContainer, AuthPageContent } from "./AuthPageLayout.styled";

interface AuthPageLayoutProps {
  children: React.ReactNode;
  withHeaderImage?: boolean;
  contentWidth?: string | number;
}

const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({
  children,
  withHeaderImage = false,
  contentWidth,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <AuthPageContainer>
      <AppLogoIcon 
        width={isMobile ? "180" : "283"} 
        height={isMobile ? "40" : "60"}
      />
      <AuthPageContent
        withHeaderImage={withHeaderImage}
        contentWidth={contentWidth}
      >
        {children}
      </AuthPageContent>
    </AuthPageContainer>
  );
};

export default AuthPageLayout;
